<template>
  <div class="container">
    <el-col :span="6" class="container-login">
      <el-form
        ref="loginFormRef"
        :model="loginForm"
        :rules="loginFormRules"
        class="form"
      >
        <el-form-item prop="userName">
          <el-input
            clearable
            placeholder="用户名/邮箱/手机号"
            v-model="loginForm.userName"
            prefix-icon="el-icon-user"
          />
        </el-form-item>
        <el-form-item prop="userPassword">
          <el-input
            clearable
            placeholder="密码"
            v-model="loginForm.userPassword"
            prefix-icon="el-icon-lock"
            type="password"
            v-on:keyup.enter.native="handleLogin"
          />
        </el-form-item>
        <el-form-item style="margin: 0">
          <el-button
            style="width: 100%"
            size="small"
            type="primary"
            @click="handleLogin"
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </el-col>
  </div>
</template>

<script>
import { login } from '@/api/index'
import Cookies from 'js-cookie'
export default {
  name: 'login',
  components: {},
  props: [],
  data() {
    return {
      loginForm: {
        userName: '',
        userPassword: '',
      },
      loginFormRules: {
        userName: [
          {
            required: true,
            message: '请输入用户名/邮箱/手机号',
            trigger: 'blur',
          },
          {
            min: 2,
            max: 20,
            message: '长度在 2 到 20 个字符',
            trigger: 'blur',
          },
        ],
        userPassword: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            min: 6,
            max: 15,
            message: '长度在 6 到 15 个字符',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginFormRef.validate(async (valid) => {
        if (!valid) return
        await login(this.loginForm).then((res) => {
          const { data } = res
          if (res.statusCode !== 200) return
          this.$message({
            type: 'success',
            message: '登录成功',
            showClose: true,
          })
          Cookies.set('token', data.token)
          this.$store.commit('SET_LOGIN', true)
          this.$router.go(-1)
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: calc(100vh - 35px);
  background-image: url('../assets/images/bg2.jpg');
  background-size: 100% 100%;
  position: relative;
  &-login {
    position: absolute;
    top: 20vh;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.3);
    padding: 16px;
    border-radius: 4px;
    font-size: 14px;
    transition: all 0.2s ease-in-out;
  }
}

@media (max-width: 800px) {
  .container {
    &-login {
      width: 50%;
    }
  }
}
@media (max-width: 600px) {
  .container {
    &-login {
      width: 80%;
    }
  }
}
</style>
